import { Route, Routes, useLocation } from "react-router";
import "./App.scss";
import RegistrationForm from "./components/Registration/registration";
import Login from "./components/Login/Login";
import ForgetPassword from "./components/ForgetPassword/ForgetPassword";
import ChangePassword from "./components/UpdatePassword/ChangePassword";
import HomePage from "./pages/HomePage/HomePage";
import Header from "./components/Header/Header";
import Profile from "./pages/Profile/Profile";
import { Suspense, useEffect, useMemo, useState } from "react";
import { getPathNames, kebabToCamelCase } from "./utils/helpers";
import { setBreadCrumbItems } from "./redux/slices/breadCrumbSlice";
import { useDispatch, useSelector } from "react-redux";
import BMCPageContainer from "./pages/BMCPageContainer/BMCPageContainer";
import Dashboard from "./pages/BMCPageContainer/Dashboard/Dashboard";
import BMCWithRating from "./pages/BMCPageContainer/CivilDefense/BMCWithRating/BMCWithRating";
import SendRequestToBMC from "./pages/BMCPageContainer/CivilDefense/SendRequestToBMC/SendRequestToBMC";
import CDDashboard from "./pages/BMCPageContainer/CivilDefense/CDDashboard/CDDashboard";
import CDProfile from "./pages/BMCPageContainer/CivilDefense/Profile/CDProfile";
import PreventiveAppointmentList from "./pages/BMCPageContainer/PreventiveAppointment/ViewPreventiveAppointment/PreventiveAppointmentList";
import BreachedPreventiveAppointmentList from "./pages/BMCPageContainer/PreventiveAppointment/ViewPreventiveAppointment/BreachedPreventiveAppointmentList";
import MaintenanceRequests from "./pages/BMCPageContainer/MaintenanceRequests/MaintenanceRequests";
import { RoutePaths } from "./resources/enum";
import Search from "./components/AssignBuilding/Search";
import BuildingDetails from "./components/AssignBuilding/Details";
import BuildingContract from "./components/AssignBuilding/Contract";
import BuildingSystems from "./components/AssignBuilding/Systems";
import BuildingConsent from "./components/AssignBuilding/Consent";
import AssignedBuildings from "./pages/BMCPageContainer/AssignedBuildings/AssignedBuildings";
import Footer from "./components/Footer/Footer";
import ATECases from "./pages/BMCPageContainer/ATECases/ATECases";
import BreachedATECases from "./pages/BMCPageContainer/ATECases/BreachedATECases";
import AppPageContainer from "./pages/BMCPageContainer/AppPageContainer";
import EditProfileButton from "./components/EditProfile/EditProfileButton";
import Survey from "./pages/BMCPageContainer/AssignedBuildings/Survey/survey";
import { ToastContainer } from "react-toastify";
import { AUTH_TOKEN, devLocationOrigin, LANGuAGE_COOKIE } from "src/resources/constant";
import AssignedBuildingDetails from "./pages/BMCPageContainer/AssignedBuildings/AssignedBuildingDetails";
import Invoices from "./pages/BMCPageContainer/Invoices/Invoices";

import { LoadingIndicator } from "./components/loadingIndiactor/loadingIndiactor";
import Cookies from "js-cookie";
import { setToken } from "./redux/slices/bMCProfileSlice";
import PaymentSuccess from "./pages/BMCPageContainer/Payment/PaymentSuccess";
import Invoice from "./components/AssignBuilding/Invoice";
import ConsolidatedInvoiceDetails from "./pages/BMCPageContainer/Invoices/ConsolidatedInvoice/ConsolidatedInvoiceDetails";
import { isCivilDefenseUser } from "src/utils/helpers";
import PaymentFail from "./pages/BMCPageContainer/Payment/PaymentFail";
import AboutUs from "./pages/AboutUs/AboutUs";
import PrivacyPolicy from "./pages/PrivacyPolicy/PrivacyPolicy";
import TermsAndConditions from "./pages/TermsAndConditions/TermsAndConditions";

const App = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const bmcpaths = [
    RoutePaths.Dashboard,
    RoutePaths.CDDashboard,
    RoutePaths.PreventiveAppointment,
    RoutePaths.MaintenanceRequests,
    RoutePaths.ATECases,
    RoutePaths.AllCases,
    RoutePaths.AssignedBuildings,
    RoutePaths.BuildingDetails,
    RoutePaths.ViewInvoices,
    RoutePaths.AssignedBuildingDetails,
    RoutePaths.Survey,
    RoutePaths.BreachedPreventiveAppointments,
    RoutePaths.BreachedCases,
    RoutePaths.BMCWithRating,
    RoutePaths.SendRequestToBMC,
  ];
  const isActive = bmcpaths.some((path: string) =>
    location.pathname.includes(path)
  );
  const isLoggedIn = useSelector((state: any) => state.bMCProfile.token);
  const [selectedLanguage, setSelectedLanguage] = useState<any>(Cookies.get(LANGuAGE_COOKIE));
  const language = useSelector((state: any) => state.lookup.language);

  const breadCrumbsPaths = useMemo(() => {
    const pathnames = getPathNames(location);
    return pathnames.map((pathname: string, index: number) => {
      let routeTo = `/${pathnames.slice(0, index + 1).join("/")}`;
      const label: string = kebabToCamelCase(pathname);
      return {
        label,
        routeTo,
      };
    });
  }, [location]);

  useEffect(() => {
    dispatch(setBreadCrumbItems(breadCrumbsPaths));
  }, [dispatch, breadCrumbsPaths]);

  useEffect(() => {
    const token = Cookies.get(AUTH_TOKEN);
    if (token) {
      dispatch(setToken(token));
    } else if (window.location.origin === devLocationOrigin) {
      dispatch(setToken("local"));
    }
  }, []);
  
  return (
    <div className="container-fluid" id="home">
      <LoadingIndicator />
      <Header />
      <div style={{ direction: language == "ar" ? "rtl" : "ltr" }}
        className={`main-content ${isActive ? "d-flex" : ""} `}>
        <ToastContainer />
        <Suspense fallback={<div>Loading...</div>}>
          <Routes>
            <Route index Component={HomePage} />
            <Route
              path={RoutePaths.Register}
              element={
                <AppPageContainer>
                  <RegistrationForm />
                </AppPageContainer>
              }
            />
            {!isCivilDefenseUser() && (
              <Route
                path={RoutePaths.Profile}
                element={
                  isLoggedIn ? (
                    <AppPageContainer RightComponent={EditProfileButton}>
                      <Profile />
                    </AppPageContainer>
                  ) : (
                    <div>you are not logged in</div>
                  )
                }
              />
            )}
            <Route
              path={RoutePaths.CDProfile}
              element={
                isLoggedIn ? (
                  <AppPageContainer>
                    <CDProfile />
                  </AppPageContainer>
                ) : (
                  <div>you are not logged in</div>
                )
              }
            />
            <Route
              path={RoutePaths.Login}
              element={
                <AppPageContainer>
                  <Login />
                </AppPageContainer>
              }
            />
            <Route
              path={RoutePaths.ForgetPassword}
              element={
                <AppPageContainer>
                  <ForgetPassword />
                </AppPageContainer>
              }
            />
            <Route
              path={RoutePaths.ChangePassword}
              element={
                <AppPageContainer>
                  <ChangePassword />
                </AppPageContainer>
              }
            />
            <Route
              path={RoutePaths.Survey}
              element={
                <BMCPageContainer>
                  <Survey />
                </BMCPageContainer>
              }
            />
            <Route
              path={RoutePaths.BuildingDetails}
              element={
                <BMCPageContainer>
                  <BuildingDetails />
                </BMCPageContainer>
              }
            />
            <Route
              path={RoutePaths.AssignedBuildingDetails}
              element={
                <BMCPageContainer>
                  <AssignedBuildingDetails />
                </BMCPageContainer>
              }
            />
            <Route
              path={RoutePaths.BuildingContract}
              element={
                <BMCPageContainer>
                  <BuildingContract />
                </BMCPageContainer>
              }
            />
            <Route
              path={RoutePaths.BuildingSystems}
              element={
                <BMCPageContainer>
                  <BuildingSystems />
                </BMCPageContainer>
              }
            />
            <Route
              path={RoutePaths.BuildingConsent}
              element={
                <BMCPageContainer>
                  <BuildingConsent />
                </BMCPageContainer>
              }
            />
            <Route
              path={RoutePaths.PayInvoice}
              element={
                <BMCPageContainer>
                  <Invoice />
                </BMCPageContainer>
              }
            />
            {!isCivilDefenseUser() && (
              <Route
                path={RoutePaths.Dashboard}
                element={
                  <BMCPageContainer className="dashboard-page">
                    <Dashboard />
                  </BMCPageContainer>
                }
              />
            )}
            {isCivilDefenseUser() && (
              <Route
                path={RoutePaths.CDDashboard}
                element={
                  <BMCPageContainer className="dashboard-page">
                    <CDDashboard />
                  </BMCPageContainer>
                }
              />
            )}
            <Route
              path={RoutePaths.PreventiveAppointment}
              element={
                <BMCPageContainer>
                  <PreventiveAppointmentList />
                </BMCPageContainer>
              }
            />
            {isCivilDefenseUser() && (
              <Route
                path={RoutePaths.BreachedPreventiveAppointments}
                element={
                  <BMCPageContainer>
                    <BreachedPreventiveAppointmentList />
                  </BMCPageContainer>
                }
              />
            )}
            {isCivilDefenseUser() && (
              <Route
                path={RoutePaths.BreachedCases}
                element={
                  <BMCPageContainer>
                    <BreachedATECases />
                  </BMCPageContainer>
                }
              />
            )}
            {!isCivilDefenseUser() && (
              <Route
                path={RoutePaths.MaintenanceRequests}
                element={
                  <BMCPageContainer>
                    <MaintenanceRequests />
                  </BMCPageContainer>
                }
              />
            )}
            {isCivilDefenseUser() && (
              <Route
                path={RoutePaths.BMCWithRating}
                element={
                  <BMCPageContainer>
                    <BMCWithRating />
                  </BMCPageContainer>
                }
              />
            )}
            {isCivilDefenseUser() && (
              <Route
                path={RoutePaths.SendRequestToBMC}
                element={
                  <BMCPageContainer>
                    <SendRequestToBMC />
                  </BMCPageContainer>
                }
              />
            )}
            {!isCivilDefenseUser() && (
              <Route
                path={RoutePaths.ATECases}
                element={
                  <BMCPageContainer>
                    <ATECases />
                  </BMCPageContainer>
                }
              />
            )}
            {isCivilDefenseUser() && (
              <Route
                path={RoutePaths.AllCases}
                element={
                  <BMCPageContainer>
                    <ATECases isAllCases={true} />
                  </BMCPageContainer>
                }
              />
            )}
            <Route
              path={RoutePaths.AssignedBuildings}
              element={
                <BMCPageContainer>
                  <AssignedBuildings />
                </BMCPageContainer>
              }
            />
            <Route
              path={RoutePaths.ViewInvoices}
              element={
                <BMCPageContainer>
                  <Invoices />
                </BMCPageContainer>
              }
            />
            <Route
              path={RoutePaths.ViewConsolidatedInvoiceDetails}
              element={
                <BMCPageContainer>
                  <ConsolidatedInvoiceDetails />
                </BMCPageContainer>
              }
            />
            <Route
              path={RoutePaths.SearchForBuilding}
              element={
                <BMCPageContainer>
                  <Search />
                </BMCPageContainer>
              }
            />
            <Route
              path={RoutePaths.PaymentSuccess}
              element={
                <AppPageContainer>
                  <PaymentSuccess />
                </AppPageContainer>
              }
            />
            <Route
              path={RoutePaths.PaymentFail}
              element={
                <AppPageContainer>
                  <PaymentFail />
                </AppPageContainer>
              }
            />
            <Route
              path={RoutePaths.AboutUs}
              element={
                <AppPageContainer>
                  <AboutUs />
                </AppPageContainer>
              }
            ></Route>
            <Route
              path={RoutePaths.PrivacyPolicy}
              element={
                <AppPageContainer className="terms-and-conditions-page">
                  <PrivacyPolicy />
                </AppPageContainer>
              }
            ></Route>
            <Route
              path={RoutePaths.TermsAndConditions}
              element={
                <AppPageContainer className="terms-and-conditions-page">
                  <TermsAndConditions />
                </AppPageContainer>
              }
            ></Route>
          </Routes>
        </Suspense>
      </div>
      <Footer />
    </div>
  );
};

export default App;
